import { countBusinessDaysUntil } from "./business-days.mjs";

const JADLOG_EXTRA_DEADLINE_DAYS = 0;
const JADLOG_SERVICE_NAMES = new Set(["jadlog", "expresso1", "economico1"]);

export const TODAY_DEADLINE_LABEL = "Hoje";

function normalizeServiceName(value) {
  if (typeof value !== "string") return "";

  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9]/g, "")
    .toLowerCase();
}

function parseDeadlineDays(deadline) {
  if (typeof deadline === "number" && Number.isFinite(deadline)) return deadline;
  if (typeof deadline === "string" && deadline.trim() !== "" && Number.isFinite(+deadline)) return +deadline;
  if (!deadline) return null;

  const days = deadline.days;
  if (typeof days === "number" && Number.isFinite(days)) return days;
  if (typeof days === "string" && days.trim() !== "" && Number.isFinite(+days)) return +days;

  return null;
}

export function isJadlogDeadline(item) {
  const normalizedName = normalizeServiceName(item && item.name);
  return JADLOG_SERVICE_NAMES.has(normalizedName);
}

export function getDisplayedDeadlineDays(item, deadline) {
  const parsedDeadline = typeof deadline === "undefined" && item ? item.deadline : deadline;
  const days = parseDeadlineDays(parsedDeadline);
  if (days === null || days <= 0) return null;

  return isJadlogDeadline(item) ? days + JADLOG_EXTRA_DEADLINE_DAYS : days;
}

// Prazo 0 = entrega no mesmo dia (EuEntrego sameday/samedayexpress).
export function isSameDayDeadline(item, deadline) {
  const parsedDeadline = typeof deadline === "undefined" && item ? item.deadline : deadline;
  return parseDeadlineDays(parsedDeadline) === 0;
}

export function formatDeadlineDays(item, deadline) {
  if (isSameDayDeadline(item, deadline)) return TODAY_DEADLINE_LABEL;

  const days = getDisplayedDeadlineDays(item, deadline);
  if (days === null) return null;

  return `${days} dia${days > 1 ? "s úteis" : " útil"}`;
}

export function countJadlogDays(date) {
  // Guard: aceita apenas string "DD/MM/YYYY"; retorna fallback para outros tipos
  if (typeof date !== "string" || !/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(date)) {
    return "";
  }

  const [day, month, year] = date.split('/').map(Number);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const targetDate = new Date(year, month - 1, day);
  targetDate.setHours(0, 0, 0, 0);

  if (Number.isNaN(targetDate.getTime())) {
    return "";
  }

  // Dias úteis = seg-sex fora de feriado nacional, o mesmo calendário que grava
  // a previsão na etiqueta (issue #1760).
  const businessDays = countBusinessDaysUntil(today, targetDate);

  if (businessDays === 0) {
    return TODAY_DEADLINE_LABEL;
  }

  return `${businessDays} dia${businessDays !== 1 ? 's úteis' : ' útil'}`;
}
